import React from 'react';
import styled from "styled-components";

export default ({type, msg, loading_stats}) => {
    return(
        <SpinnerStyle className={'loading-spinner ' + (loading_stats ? 'loading-stats' : '')}>
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </SpinnerStyle>
    )
}

const SpinnerStyle = styled.div`
  text-align:center;
 .lds-ellipsis {
    /*display: inline-block;*/
    position: relative;
    width: 64px;
    height: 11px;
  }
  .lds-ellipsis div {
    position: absolute;
    /*top: 27px;*/
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #991515;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 6px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 26px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 45px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  &.loading-stats{
    .lds-ellipsis{
      width: 48px;
      height: 6px;
      div{
        width: 6px;
        height: 6px;
        background: #878787;
      }
    }
    .lds-ellipsis div:nth-child(1) {
      left: 4px;
      animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
      left: 4px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
      left: 20px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
      left: 36px;
      animation: lds-ellipsis3 0.6s infinite;
    }
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }
  
`